<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <form id="FormComisionesxAgente" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                <div class="container-fluid">
                    <div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<!-- <div class="form-group form-row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="Categoria">Categoría</label>
									<input type="text" v-model="objCategoriaGaleria.Categoria" class="form-control" id="Categoria" placeholder="Ingresar Categoria" />
									<CValidation v-if="this.errorvalidacion.Categoria" :Mensaje="'*'+errorvalidacion.Categoria[0]"/>
								</div>
							</div> -->
                            <div v-for="(item,index) in ComisionesLista" :key="index" class="form-group form-row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div class="form-check">
                                        <input :value="item.IdComision" v-model="objComisionesxAgente.Comisiones" type="checkbox" :id="index">
                                        <label for="">{{ item.Cantidad }}</label>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
                </div>
            </form>
        </template>
    </CLoader>
</template>

<script>
    export default{
        name: 'FormComisionesxAgente',
        props: ['poBtnSave'],
        data(){
            return{
                ConfigLoad:{
                    ShowLoader: true,
                    ClassLoad: false,
                },
                objComisionesxAgente: {
                    Comisiones:[],
			    	IdAgente: 0,
                
                },
                errorvalidacion: [],
			    Emit: this.poBtnSave.EmitSeccion,
                ComisionesLista:[]
            }
        },
        methods:{
            async Guardar(){
                await this.$http.post("/comisiones",objComisionesxAgente)
            },
            EjecutaConExito(res){

            },
            EjecutaConError(err){

            },
            Recuperar(){

            },
            Limpiar(){

            },
            async RecuperarComisiones(){
                let arr=[];
                await this.$http.get("/comisiones",{
                    params:{
                        Entrada: 20,
                        Pag: 1,
                    }
                }).then((res) => {
                    arr=res.data.data.data;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                });
                this.ComisionesLista=arr;
                console.log(this.ComisionesLista);
                console.log(this.ConfigLoad.ShowLoader);
            }
        },
        created(){
            this.RecuperarComisiones();
            this.bus.$off('ListaComisiones')
            this.bus.$on('ListaComisiones',()=>{
                // this.RecuperarComisiones();
            });
        }
    }
    
</script>